// experience
export const EXPERIENCE_ENDED = 'experience:ended';
export const EXPERIENCE_LOADED = 'experience:loaded';

// point
export const POINT_LOADED = 'point:loaded';

// story
export const STORY_COORDINATES_FOUND = 'story:coordinatesFound';
export const STORY_ENDED = 'story:ended';
export const STORY_LOADED = 'story:loaded';
export const PLACE_LOADED = 'place:loaded';

// overlay
export const OVERLAY_PARAMETERS = 'overlay:parameters';

// portal
export const PORTAL_PARAMETERS = 'portal:parameters';

// actions

export const ACTION_ENABLE_COORDS_SELECT_MODE = 'actions:enableCoordsSelectMode';
export const ACTION_TOGGLE_CONTENT_VISIBILITY = 'actions:toggleContentVisibility';

export const ACTION_TOGGLE_POINT_AUDIO = 'actions:togglePointAudio';

export const ACTION_TOGGLE_STICK = 'actions:toggleStick';
export const ACTION_TOGGLE_CAMERA_SYNC = 'actions:toggleCameraSync';

// sync

export const SYNC_CAMERA_ROTATION = 'sync:cameraRotation';

export const SYNC_LOCATION_UPDATE = 'sync:location:update';

export const SYNC_LOCATION_SET = 'sync:location:set';

export const SYNC_POINT_AUDIO_STATE = 'sync:point:audio:state';

export const ACTION_PLAY_EMBED_VIDEO = 'actions:playEmbedVideo';
